import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import CameraScannerButton from "@/components/CameraScannerButton";
import { beep } from "@/lib/beep";
import { ScanLine, Plus, Minus } from "lucide-react";

// Bipagem rápida estilo PDV: cada leitura envia direto (câmera contínua + beep).
// Mantém o mesmo contrato onScan({codigo, quantidade, is_master}) do ScanInput antigo.
export default function FastScanInput({ onScan, label = "Escanear / Bipar", testid = "fast-scan" }) {
  const [codigo, setCodigo] = useState("");
  const [qtd, setQtd] = useState(1);
  const [isMaster, setIsMaster] = useState(false);

  const fire = (code) => {
    const c = (code ?? codigo).trim();
    if (!c) return;
    try { beep(); } catch (_) {}
    onScan({ codigo: c, quantidade: Number(qtd) || 1, is_master: isMaster });
    setCodigo("");
  };

  return (
    <div className="rounded-lg border border-primary/40 bg-black/40 p-4 space-y-3" data-testid={`${testid}-panel`}>
      <div className="flex items-center gap-2 text-primary text-xs font-bold uppercase tracking-[0.18em]">
        <ScanLine className="w-4 h-4" /> {label}
      </div>
      <div className="flex gap-2">
        <Input autoFocus value={codigo} onChange={(e) => setCodigo(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && fire()}
          placeholder="EAN / SKU / Master" inputMode="text" autoComplete="off"
          data-testid={`${testid}-input`}
          className="text-xl font-mono h-12 bg-black/70 border-2 border-primary/60 text-primary" />
        <Button type="button" variant="outline" className="h-12" onClick={() => fire()} data-testid={`${testid}-btn`}><ScanLine className="w-5 h-5" /></Button>
        <CameraScannerButton continuous onDetected={(c) => fire(c)} className="h-12 px-4 shrink-0" testid={`${testid}-camera`} />
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        <div className="flex items-center gap-1">
          <span className="text-xs text-muted-foreground uppercase mr-1">Qtd</span>
          <Button type="button" size="icon" variant="outline" className="h-9 w-9" onClick={() => setQtd((q) => Math.max(1, (Number(q) || 1) - 1))} data-testid={`${testid}-minus`}><Minus className="w-3 h-3" /></Button>
          <Input type="number" min={1} value={qtd} onChange={(e) => setQtd(e.target.value)} className="w-16 h-9 text-center font-mono" data-testid={`${testid}-qtd`} />
          <Button type="button" size="icon" variant="outline" className="h-9 w-9" onClick={() => setQtd((q) => (Number(q) || 1) + 1)} data-testid={`${testid}-plus`}><Plus className="w-3 h-3" /></Button>
        </div>
        <label className="flex items-center gap-2 text-xs text-muted-foreground cursor-pointer">
          <input type="checkbox" checked={isMaster} onChange={(e) => setIsMaster(e.target.checked)} data-testid={`${testid}-master`} />
          Caixa Master
        </label>
      </div>
      <p className="text-[11px] text-muted-foreground">No celular, use a câmera para bipar vários produtos em sequência sem reabrir.</p>
    </div>
  );
}
